<div class="container-fluid">
    <div class="row">
        <div class="error-text-wrapp">
            <div class="text-404">
                <div class="error-image-wrapp">
                    <img src="assets/images/404-img.png" alt="404" class="error-image">
                </div>
                <p class="not-found-text">Page Not Found</p>
                <p class="subtext-404">
                    The page you were looking for could not be found</p>
                <div class="backbutton go-back-home">
                    <a type="button" class="btn btn-primarytheme back-home" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="15" viewBox="0 0 19 15" fill="none"
                            class="change-color">
                            <path
                                d="M17.4062 6.78118H3.06755L8.55808 1.55156C8.84558 1.27771 8.85672 0.822744 8.58287 0.535244C8.30939 0.248103 7.85442 0.236603 7.56656 0.510447L1.29619 6.48326C1.02486 6.75495 0.875 7.11576 0.875 7.49993C0.875 7.88374 1.02486 8.24492 1.30877 8.52846L7.56692 14.4891C7.706 14.6217 7.88425 14.6874 8.0625 14.6874C8.25225 14.6874 8.442 14.6127 8.58323 14.4643C8.85708 14.1768 8.84594 13.7221 8.55844 13.4483L3.04491 8.21868H17.4062C17.803 8.21868 18.125 7.89668 18.125 7.49993C18.125 7.10318 17.803 6.78118 17.4062 6.78118Z"
                                fill="white"></path>
                        </svg> Back To Homepage</a>
                </div>
            </div>
        </div>
    </div>
</div>